<template>
  <b-row id="footer">
    <b-col>
      <!-- Icon and newsletter section section -->
      <b-row class="justify-content-center">
        <b-col class="text-center pt-3 footer--left" xs="12" md="4">
          <img src="../../reflectionsLogo.png" alt class="company-logo px-4" />
          <p class="footer-text my-2">All commercial rights reserved. © Reflections 2020</p>
          <p class="footer-text my-2">Powered by <a href="https://blankpage-agency.com" style="text-decoration:underline;" target="_blank">BlankPage Agency</a></p>
        </b-col>
        <b-col class="text-center pt-3 footer--right" xs="12" md="4">
          <h6 class="footer-text">
            Subscribe to our newsletter for <br>the latest updates!
          </h6>

          <div class="mx-4 mb-2">
            <subscription-component></subscription-component>
          </div>
          <!-- Extra info txt -->
          <ul class="footer-text">
            <li>
              <font-awesome-icon icon="envelope"></font-awesome-icon>&nbsp;<a href="mailto:reflects@eim.ae">reflects@eim.ae</a>
            </li>
            <li>
              <font-awesome-icon icon="phone"></font-awesome-icon>&nbsp;+97143470542
            </li>
          </ul>
          <!-- <h6 class="footer-text py-3"></h6> -->
        </b-col>
      </b-row>

      <!-- Links section -->
      <b-row>
        <b-col class="text-center">
          <hr class="divider" />
          <ul>
            <li>
              <a href="#">Terms of use</a>
            </li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
            <li>
              <a href="#" v-on:click="$router.push({name: 'Contact'})">FAQ</a>
            </li>
            <li>
              <a href="#" v-on:click="$router.push({name: 'Contact'})">Contact</a>
            </li>
          </ul>
          <hr class="divider" />
        </b-col>
      </b-row>

      <!-- back to top -->
      <b-row class="my-2">
        <b-col class="text-center">
          <a href="#">
            Back to top &nbsp;
            <font-awesome-icon icon="chevron-up"></font-awesome-icon>
          </a>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import SubscriptionComponent from "./footer-components/subscription-component.vue";

export default {
  name: "Footer",
  components: { SubscriptionComponent },
};
</script>

<style>
#footer {
  background: #333333;
  padding-top: 30px;
  padding-bottom: 30px;
  /* position: absolute;
  bottom: 0;
  left: 0; */
  /* width: 100%;
  height: 32vh; */
}
#footer .footer--left li {
  font-size: 20px;
}
#footer .footer--left .footer-text {
  color: white;
  font-size: 14px;
}
#footer .footer--right .footer-text {
  color: #ffffff;
  font-weight: 300;

  font-style: italic;
  font-size: 18px;
}
#footer .footer--right #footer-email {
  height: 35px;
}
#footer .footer--right .input-group-text {
  background: #4d4d4d;
  border-color: #4d4d4d;
  color: white;
  font-size: 22px;
  padding: 3px;
  padding-left: 10px;
  padding-right: 10px;
}
#footer .company-logo {
  width: 300px;
  height: auto;
}

#footer-email {
  border-radius: none !important;
}

#footer-email::placeholder {
  color: #b7b7b7;
  font-size: small;
  padding-left: 0.5rem;
}
</style>

<style scoped>
ul > li {
  display: inline-block;
  zoom: 1;
  margin-left: 1em;
  margin-right: 1em;
}
ul {
  padding-inline-start: 0;
}
hr {
  color: #ffffff;
  background-color: #ffffff;
  padding: 0px;
}

a {
  text-decoration: none;
  color: white;
}

hr .divider {
  padding-left: 0px;
}
</style>
